import { rtdb } from "../utility/firebase";
import {
  ref,
  onDisconnect,
  onValue,
  serverTimestamp,
  set,
} from "firebase/database";
import { getAuth } from "firebase/auth";

export const firebasePresenceInit = (uid) => {
  const userStatusDatabaseRef = ref(rtdb, "/status/" + uid);
  const isOfflineForDatabase = {
    state: "offline",
    last_changed: serverTimestamp(),
  };
  const isOnlineForDatabase = {
    state: "online",
    last_changed: serverTimestamp(),
  };

  const connectedRef = ref(rtdb, ".info/connected");
  onValue(connectedRef, (snapshot) => {
    /* if not connected */
    if (snapshot.val() == false) {
      return;
    }

    onDisconnect(userStatusDatabaseRef)
      .set(isOfflineForDatabase)
      .then(() => {
        /* run this whenever value changed to connected */
        set(userStatusDatabaseRef, isOnlineForDatabase);
      });
  });
};
